import { render, staticRenderFns } from "./SafetyProblem.vue?vue&type=template&id=4cc8ea9d&scoped=true"
import script from "./SafetyProblem.vue?vue&type=script&lang=js"
export * from "./SafetyProblem.vue?vue&type=script&lang=js"
import style0 from "./SafetyProblem.vue?vue&type=style&index=0&id=4cc8ea9d&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4cc8ea9d",
  null
  
)

export default component.exports